"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var OMITTED_STATUSES = ['PENDING_MASTER'];

var remove_omitted = function remove_omitted(statuses) {
  return statuses.filter(function (item) {
    return !OMITTED_STATUSES.includes(item);
  });
};

var buildSmartProgressData = function buildSmartProgressData(statuses, status, isInternal) {
  // For on-hold, build an artificial/synthetic progress indicator
  if (status === 'ON_HOLD') {
    return {
      statuses: ['ON_HOLD'],
      index: 0
    };
  } // Find important borders in workflow


  var thisStatusAt = statuses.findIndex(function (item) {
    return item === status;
  });
  var editingStartsAt = statuses.findIndex(function (item) {
    return item === 'EDITING';
  });
  var editingEndsAt = statuses.findIndex(function (item) {
    return item === 'INTERNAL_REVIEW';
  });
  var completeAt = statuses.findIndex(function (item) {
    return item === 'APPROVED';
  }); // Which major section of the workflow are we in?

  var isSubmitting = thisStatusAt < editingStartsAt;
  var isEditing = thisStatusAt >= editingStartsAt && thisStatusAt <= editingEndsAt; // Assemble final status array

  var submitSteps = [];
  var editSteps = isInternal ? statuses.slice(editingStartsAt, editingEndsAt + 1) : ['EDITING_IN_PROGRESS'];
  var clientSteps = statuses.slice(editingEndsAt + 1, completeAt + 1);
  var finalStatuses = remove_omitted([].concat(submitSteps, _toConsumableArray(editSteps), _toConsumableArray(clientSteps)));
  return {
    statuses: finalStatuses,
    index: finalStatuses.findIndex(function (item) {
      return item === status || isSubmitting && item === 'SUBMIT' || isEditing && item === 'EDITING_IN_PROGRESS';
    })
  };
};

var _default = buildSmartProgressData;
exports.default = _default;